var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloppyDisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M22.1 8.6v8.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M28.1 7.3H13.7C10.5 7.3 8 9.5 8 12.2v18.2c0 2.7 2.5 4.9 5.7 4.9h15.2c3.1 0 5.7-2.2 5.7-4.9V14.9l-6.5-7.6zM11 8.6h16.8v5.3c0 1.7-1.3 3-3 3H14c-1.7 0-3-1.3-3-3V8.6zm20.5 24.9H11V21c0-1.4 1-2.5 2.3-2.5h15.8c1.3 0 2.3 1.1 2.3 2.5v12.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDisk);
export default __webpack_public_path__ + "static/media/floppyDisk.d34af74d4391143a488476ed4d3303ed.svg";
export { ForwardRef as ReactComponent };